export const BRIEFS_PAGE_SIZE = 10;

export const BRIEF_TABS = ['all', 'attn', 'live', 'draft', 'paused', 'completed'] as const;
export type BriefTab = (typeof BRIEF_TABS)[number];

export const BRIEF_SORTS = ['updated', 'end', 'name', 'creators'] as const;
export type BriefSort = (typeof BRIEF_SORTS)[number];

export const BRIEF_TYPES = ['ugc', 'screening', 'monitoring'] as const;
export type BriefType = (typeof BRIEF_TYPES)[number];

export type BriefStatus = 'live' | 'draft' | 'paused' | 'completed';
export type BriefEndsKind = 'date' | 'ongoing' | 'none';
export type BriefActionKind = 'approve' | 'flags' | 'posts' | 'screen' | 'apply' | 'setup';

export interface BriefListQuery {
  tab: BriefTab;
  q: string;
  types: BriefType[];
  products: string[];
  owners: string[];
  campaign: string;
  sort: BriefSort;
  page: number;
}

export interface BriefOwner {
  id: string;
  name: string;
}

export interface BriefListItem {
  id: string;
  name: string;
  type: BriefType;
  status: BriefStatus;
  product: { id: string; name: string; image: string };
  owner: BriefOwner | null;
  creatorCount: number;
  /** Creators the brief asks for. Present on UGC rows. */
  requiredCreators: number | null;
  updatedAt: string;
  endsAt: string | null;
  endsKind: BriefEndsKind;
  pausedAt: string | null;
  pendingAction: { kind: BriefActionKind; count: number } | null;
}

export interface BriefFacet {
  id: string;
  name: string;
  count: number;
}

export interface BriefsListResponse {
  rows: BriefListItem[];
  total: number;
  unfilteredTotal: number;
  tabCounts: Record<BriefTab, number>;
  facets: {
    types: BriefFacet[];
    products: BriefFacet[];
    owners: BriefFacet[];
  };
}

export interface BriefsListRequest {
  businessAccountId: string;
  tab: BriefTab;
  search: string;
  types: BriefType[];
  productIds: string[];
  ownerIds: string[];
  campaignId: string | null;
  sort: BriefSort;
  skip: number;
  take: number;
}

export interface SavedBriefView {
  id: string;
  name: string;
  tab: BriefTab;
  types: BriefType[];
  products: string[];
  owners: string[];
}

export const DEFAULT_BRIEF_QUERY: BriefListQuery = {
  tab: 'all',
  q: '',
  types: [],
  products: [],
  owners: [],
  campaign: '',
  sort: 'updated',
  page: 1,
};

export const PRESET_BRIEF_VIEWS: SavedBriefView[] = [
  { id: 'mine', name: 'My briefs', tab: 'all', types: [], products: [], owners: ['me'] },
  { id: 'scr', name: 'Screening to review', tab: 'attn', types: ['screening'], products: [], owners: [] },
  { id: 'ugc', name: 'Live UGC', tab: 'live', types: ['ugc'], products: [], owners: [] },
];

export function emptyBriefsResponse(): BriefsListResponse {
  return {
    rows: [],
    total: 0,
    unfilteredTotal: 0,
    tabCounts: { attn: 0, live: 0, draft: 0, paused: 0, completed: 0, all: 0 },
    facets: { types: [], products: [], owners: [] },
  };
}
